import React, {Component} from 'react';

// Components
import CreatorsStatesAnalytics from 'js/campaign_analytics/campaign_wrap_up/analytics_shared/creators_states_analytics';
import GenderAnalytics from 'js/campaign_analytics/campaign_wrap_up/analytics_shared/gender_analytics';
import InterestsAnalytics from 'js/campaign_analytics/campaign_wrap_up/analytics_shared/interests_analytics';
import AgeAnalytics from 'js/campaign_analytics/campaign_wrap_up/analytics_shared/age_analytics';
import LocationAnalytics from 'js/campaign_analytics/campaign_wrap_up/analytics_shared/location_analytics';

class CreatorOptOutAnalysis extends Component {
    displayTitle = () => {
        const {renderForPdf} = this.props;

        if (renderForPdf) {
            return <div className="creator-opt-out-title">Creator Opt Out Analysis</div>;
        }
    };

    render() {
        const {bgColor, renderForPdf, getAssetPath} = this.props;
        const title = this.displayTitle();

        return (
            <div className="creator-opt-out-analysis">
                {title}
                <div className="creator-opt-out-row-1">
                    <CreatorsStatesAnalytics
                        creatorCount={this.props.optedOutData.creator_count}
                        statesCount={this.props.optedOutData.states.counts}
                        borders={{right: true}}
                        renderForPdf={renderForPdf}
                        getAssetPath={getAssetPath}
                    />
                    <GenderAnalytics
                        femalePercentage={this.props.optedOutData.genders.percentages.female}
                        malePercentage={this.props.optedOutData.genders.percentages.male}
                        borders={{left: true}}
                        renderForPdf={renderForPdf}
                        getAssetPath={getAssetPath}
                    />
                </div>
                <div className="creator-opt-out-row-2">
                    <InterestsAnalytics
                        interests={this.props.optedOutData.interests}
                        elementId="creator-opt-out-interests"
                        bgColor={bgColor}
                        borders={{right: true}}
                        renderForPdf={renderForPdf}
                    />
                    <AgeAnalytics
                        ageRangeCount={this.props.optedOutData.age_ranges.counts}
                        elementId="creator-opt-out-age"
                        bgColor={bgColor}
                        borders={{left: true}}
                        renderForPdf={renderForPdf}
                    />
                </div>
                <div className="creator-opt-out-row-3">
                    <LocationAnalytics
                        countries={this.props.optedOutData.countries}
                        states={this.props.optedOutData.states}
                        borders={{}}
                        renderForPdf={renderForPdf}
                        getAssetPath={getAssetPath}
                    />
                </div>

                {/*STYLES*/}

                <style>{`
                    .creator-opt-out-analysis {
                        width: 100%;
                    }

                    .creator-opt-out-row-1 {
                        width: 100%;
                        padding: 40px 0px;
                        border-bottom: 1px solid #d4d4d4;
                    }

                    .creator-opt-out-row-2 {
                        width: 100%;
                        padding: 40px 0px;
                        border-bottom: 1px solid #d4d4d4;
                    }
                `}</style>

                {/*STYLE FOR WEB*/}
                {!renderForPdf ? (
                    <style>{`
                        .creator-opt-out-row-1 {
                            display: flex;
                            justify-content: center;
                        }

                        .creator-opt-out-row-2 {
                            display: flex;
                            justify-content: center;
                        }
                    `}</style>
                ) : null}

                {/*STYLE FOR PDF*/}
                {renderForPdf ? (
                    <style>{`
                        .creator-opt-out-analysis {
                        }

                        .creator-opt-out-title {
                            text-align: center;
                            font-size: 28px;
                            font-weight: bold;
                            color: #00A1E1;
                            padding-bottom: 20px;
                            text-transform: uppercase;
                        }
                    `}</style>
                ) : null}
            </div>
        );
    }
}

CreatorOptOutAnalysis.propTypes = {};

export default CreatorOptOutAnalysis;



// WEBPACK FOOTER //
// ./campaign_analytics/campaign_wrap_up/creator_participation_analytics/creator_opt_out_analysis.js